import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { AsideSticky, Main, Page, Content } from '../../components/Page';
import { FixedHeader } from '../FixedHeader';
import { Responsive, UiKitRoot } from '@cian/ui-kit';
import { AsideSection } from '../../components/AsideSection/AsideSection';
import { BreadCrumbs } from '../BreadCrumbs';
import { PriceBlock } from '../PriceBlock';
import { SeoLinksContainer } from '../SeoLinks/SeoLinksContainer';
import { PageTitleContainer } from '../PageTitle/PageTitle';
import { BuilderInfo } from '../BuilderInfo';
import { SpecificationsContainer } from '../Specifications';
import { BuildersContainer } from '../BuildersMobile';

import { StickyBottomLayout } from '../../components/StickyBottomLayout';
import { CallToActionContainer } from '../MobileCall';
import { DesktopPromosSection } from '../DesktopPromosSection';
import { MainSection } from '../../components/MainSection';
import { MobilePromosSection } from '../MobilePromosSection';
import { PromoDetailsContainer } from '../PromoDetails';
import { PromoPopupContainer } from '../PromoPopup';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <Page>
              <FixedHeader />
              <BreadCrumbs />
              <Content>
                <Main>
                  <Responsive desktop>
                    <SeoLinksContainer />
                  </Responsive>
                  <MainSection>
                    <PageTitleContainer />
                    <Responsive desktop>
                      <DesktopPromosSection />
                    </Responsive>
                    <Responsive tablet phone>
                      <MobilePromosSection />
                    </Responsive>
                    <SpecificationsContainer />
                  </MainSection>
                  <Responsive tablet phone>
                    <BuildersContainer />
                  </Responsive>
                  <Responsive tablet phone>
                    <SeoLinksContainer />
                  </Responsive>
                </Main>
                <AsideSticky>
                  <AsideSection>
                    <PriceBlock />
                  </AsideSection>
                  <AsideSection>
                    <BuilderInfo />
                  </AsideSection>
                </AsideSticky>
              </Content>
              <Responsive desktop>
                <PromoDetailsContainer />
              </Responsive>
              <Responsive tablet phone>
                <PromoPopupContainer />
              </Responsive>
            </Page>
            <Responsive tablet phone>
              <StickyBottomLayout>
                <CallToActionContainer />
              </StickyBottomLayout>
            </Responsive>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
